import icons from "../helpers/icons";
import React from "react";
import { withRouter } from 'react-router-dom'


const Valper = (props) => {

    const valper = props.valper;

    const onRowClick = (e, valp) => {
        e.preventDefault();
        props.history.push(`/hund?id=${valp.hundId}`)
    }

    const rows = valper.map((valp) => (
        <tr className="valp-row" key={valp.hundId} onClick={(e) => onRowClick(e, valp)} >
            <td>
                <div className="navn">
                    { valp.kjoenn === 'H' && <img className="icon hund-han" src={icons.han} alt="" /> }
                    { valp.kjoenn === 'T' && <img className="icon hund-teve" src={icons.teve} alt="" /> }
                    {valp.navn}
                </div>
            </td>
            <td className="hide-for-small-only" style={{wordBreak:' ',width:"150px"}}>{valp.tittel}</td>
            <td className="hide-for-small-only">{valp.farge}</td>
            <td className="hide-for-small-only">{valp.hd}</td>
            <td className="hide-for-small-only">{valp.ad}</td>
            <td className="hide-for-small-only">
                {valp.ocd === '1' && 'Fri'}
                {valp.ocd === '2' && 'Påvist'}
                </td>
        </tr>
    ));

    return (
        <div>
            <table className="dogweb-kuld striped" cellPadding="0" cellSpacing="0">
                <thead>
                <tr>
                    <th>
                        <div className="navn">Navn</div>
                    </th>
                    <th className="hide-for-small-only">Titel</th>
                    <th className="hide-for-small-only">Farve</th>
                    <th className="hide-for-small-only">HD</th>
                    <th className="hide-for-small-only">AD</th>
                    <th className="hide-for-small-only">OCD</th>
                </tr>
                </thead>
                <tbody>
                { rows}
                </tbody>
            </table>

        </div>
    );
};

export default withRouter(Valper);
